import { RyuImage, RyuFlex, RyuPad, RyuText, RyuBreak } from '@ramp/ryu'
import { styled } from 'styled-components'

type TestimonialProps = {
  quoteText: string
  quoteAuthorName: string
  quoteAuthorTitle: string
  stats: { title: string; description: string }[]
  imageUrl: string
  logoImageUrl: string
  gradientStrength?: number
}

export function TestimonialSidebar(props: TestimonialProps) {
  return (
    <TestimonialSidebarContainer>
      <TestimonialImageContainer>
        <TestimonialLogoImage src={props.logoImageUrl} />

        <TestimonialBackgroundImage>
          <GradientOverlay strength={props.gradientStrength} />
          <RyuImage src={props.imageUrl} />
        </TestimonialBackgroundImage>
      </TestimonialImageContainer>

      <RyuBreak size='xl' />

      <RyuFlex direction='column' alignItems='flexStart' justifyContent='spaceBetween'>
        <RyuPad sizeHorizontal='xl' sizeVertical='s'>
          <RyuText.div size='xl'>{props.quoteText}</RyuText.div>

          <RyuBreak size='l' />

          <RyuText.div size='s' color='hushed'>
            {props.quoteAuthorName}, {props.quoteAuthorTitle}
          </RyuText.div>
        </RyuPad>

        <RyuBreak />

        <RyuPad size='xl'>
          <RyuFlex gapSize='xl' alignItems='flexEnd'>
            {props.stats.map((stat) => (
              <div key={`${stat.title}-${stat.description}`}>
                <RyuText.h3 size='l' paddingVertical='none'>
                  {stat.title}
                </RyuText.h3>

                <RyuBreak size='xs' />

                <RyuText.div size='s' color='hushed'>
                  {stat.description}
                </RyuText.div>
              </div>
            ))}
          </RyuFlex>
        </RyuPad>
      </RyuFlex>
    </TestimonialSidebarContainer>
  )
}

const TestimonialSidebarContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex: 1;
  justify-content: space-between;
  flex-direction: column;
  width: 34vw;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: ${({ theme }) => theme.ryuColors.lighterShade};
`

const TestimonialLogoImage = styled.img`
  position: absolute;
  max-height: 10rem;
  height: 2rem;
  /* Make the logo white */
  filter: brightness(0) invert(1);
  top: 2rem;
  left: 2rem;
  z-index: 2;
`

const TestimonialImageContainer = styled.div`
  position: relative;
`

const TestimonialBackgroundImage = styled.div`
  img {
    max-height: 30rem;
    width: 100%;
    object-fit: cover;
    /* aspect-ratio: 16/9; */
  }
`

const GradientOverlay = styled.div<{ strength?: number }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, ${({ strength = 0.3 }) => strength}),
    rgba(0, 0, 0, 0)
  );
  z-index: 1;
`
